import { Checkbox, CheckboxGroup, HStack, VStack } from "@chakra-ui/react"
import FieldCheckboxGroup from "@pathwright/ui/src/components/form/form-checkbox/CheckboxGroup"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"
import get from "lodash/get"
import PropTypes from "prop-types"
import { useMemo } from "react"
import styled from "styled-components"
import { useStripeProductsQuery } from "@pathwright/graphql-client/src/generated"
import { flattenEdges } from "../../utils/apollo"

const StyledCheckboxGroup = styled(FieldCheckboxGroup)`
  & > div {
    align-items: flex-start;
  }
`

export const useProducts = ({ includeInactive } = {}) => {
  const productsQuery = useStripeProductsQuery({
    variables: { first: 50, includeInactive }
  })
  const products = flattenEdges(get(productsQuery, "data.stripeProducts")) || []

  return { query: productsQuery, products }
}

const productCheckboxesDefaultPropOnChange = () => {}
const productCheckboxesDefaultPropSelectedProductIds = []

const ProductCheckboxes = ({
  onChange = productCheckboxesDefaultPropOnChange,
  selectedProductIds = productCheckboxesDefaultPropSelectedProductIds,
  includeInactive,
  ...rest
}) => {
  const { products } = useProducts({ includeInactive })
  // Sort inactive products to the bottom.
  const sortedProducts = useMemo(() => {
    return products.sort((productA, productB) => {
      return (productB.active ? 1 : 0) - (productA.active ? 1 : 0)
    })
  }, [products])

  return (
    <StyledCheckboxGroup {...rest}>
      <CheckboxGroup
        value={(selectedProductIds || []).map(String)}
        onValueChange={(stringIds) => {
          onChange(stringIds.map((id) => parseInt(id, 10)))
        }}
      >
        <VStack align="stretch" gap={1}>
          {sortedProducts.map((product) => (
            <Checkbox.Root
              key={product.id}
              value={String(product.id)}
              colorPalette="blue"
              variant="solid"
            >
              <Checkbox.HiddenInput />
              <Checkbox.Control />
              <Checkbox.Label>
                <HStack>
                  {!product.active && <Pathicon icon="lock" />}
                  <span>{product.name}</span>
                </HStack>
              </Checkbox.Label>
            </Checkbox.Root>
          ))}
        </VStack>
      </CheckboxGroup>
    </StyledCheckboxGroup>
  )
}

ProductCheckboxes.displayName = "ProductCheckboxes"

ProductCheckboxes.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedProductIds: PropTypes.array.isRequired
}

export default ProductCheckboxes
